type DeleteIconProps = {
  className?: string;
  fill?: string;
};

const DeleteIcon = ({ className, fill = "#145758" }: DeleteIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.0125 6V5.9875H5C4.71981 5.9875 4.48555 5.89287 4.29634 5.70366C4.10713 5.51445 4.0125 5.28019 4.0125 5C4.0125 4.71981 4.10713 4.48555 4.29634 4.29634C4.48555 4.10713 4.71981 4.0125 5 4.0125H9H9.0125V4C9.0125 3.71981 9.10713 3.48555 9.29634 3.29634C9.48555 3.10713 9.71981 3.0125 10 3.0125H14C14.2802 3.0125 14.5145 3.10713 14.7037 3.29634C14.8929 3.48555 14.9875 3.71981 14.9875 4V4.0125H15H19C19.2802 4.0125 19.5145 4.10713 19.7037 4.29634C19.8929 4.48555 19.9875 4.71981 19.9875 5C19.9875 5.28019 19.8929 5.51445 19.7037 5.70366C19.5145 5.89287 19.2802 5.9875 19 5.9875H18.9875V6V19C18.9875 19.5467 18.793 20.0143 18.4037 20.4037C18.0143 20.793 17.5467 20.9875 17 20.9875H7C6.45334 20.9875 5.98568 20.793 5.59634 20.4037C5.207 20.0143 5.0125 19.5467 5.0125 19V6ZM17.0125 6V5.9875H17H7H6.9875V6V19V19.0125H7H17H17.0125V19V6ZM10.7037 16.7037C10.5145 16.8929 10.2802 16.9875 10 16.9875C9.71981 16.9875 9.48555 16.8929 9.29634 16.7037C9.10713 16.5145 9.0125 16.2802 9.0125 16V9C9.0125 8.71981 9.10713 8.48555 9.29634 8.29634C9.48555 8.10713 9.71981 8.0125 10 8.0125C10.2802 8.0125 10.5145 8.10713 10.7037 8.29634C10.8929 8.48555 10.9875 8.71981 10.9875 9V16C10.9875 16.2802 10.8929 16.5145 10.7037 16.7037ZM14.7037 16.7037C14.5145 16.8929 14.2802 16.9875 14 16.9875C13.7198 16.9875 13.4855 16.8929 13.2963 16.7037C13.1071 16.5145 13.0125 16.2802 13.0125 16V9C13.0125 8.71981 13.1071 8.48555 13.2963 8.29634C13.4855 8.10713 13.7198 8.0125 14 8.0125C14.2802 8.0125 14.5145 8.10713 14.7037 8.29634C14.8929 8.48555 14.9875 8.71981 14.9875 9V16C14.9875 16.2802 14.8929 16.5145 14.7037 16.7037Z"
      fill={fill}
      stroke="#145758"
      strokeWidth="0.025"
    />
  </svg>
);

export default DeleteIcon;
